/**
 * Browser redirect utilities.
 * 
 * ACT-INDEEP-ROOT-MOBILE-LOGIN01: Centralizes window.location.replace() calls
 * to allow easier mocking in tests without mutating global window object.
 */

/**
 * Navigate to a new URL, replacing the current entry in browser history.
 */
export function replaceLocation(path: string): void {
  window.location.replace(path);
}

/**
 * Navigate to a new URL by setting href (creates history entry).
 */
export function setLocationHref(path: string): void {
  window.location.href = path;
}
